import Vue from "vue";
import VueRouter from "vue-router";
// import Axios from "axios";
import Feng from "@/api/Feng";
// import { wechatLogin } from "@/api";
import Inmain from "../views/Inmain.vue";
// import Sign from "../views/Sign.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "home",
    name: "Immain",
    component: Inmain,
    children: [
      {
        // 首页
        path: "home",
        name: "Home",
        meta: {
          requireAuth: false
        },
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/Home.vue")
      }
    ]
  },
  {
    path: "/authlogin",
    name: "authLogin",
    meta: {
      requireAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "sign" */ "../views/authLogin.vue")
  },
  {
    path: "/sign",
    name: "Sign",
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "sign" */ "../views/Sign.vue")
  },
  {
    path: "/mysign",
    name: "mySign",
    meta: {
      requireAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "sign" */ "../views/mySign.vue")
  },
  {
    path: "/livepage",
    name: "livePage",
    meta: {
      requireAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "sign" */ "../views/livePage.vue")
  },
  {
    path: "/livelist",
    name: "liveList",
    meta: {
      requireAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "sign" */ "../views/liveList.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// 路由拦截
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  if (to.meta.requireAuth && !token) {
    window.location.href = Feng.BASE_URL + "/wechatLogin/loginInit";
    // wechatLogin()
    //   .then(res => {
    //     window.location.href = res.replace("redirect:", "");
    //   })
    //   .catch(() => {});
  } else {
    next();
  }
});

export default router;
